<div class="bg-white">
  <div class="card" style="border-bottom: none">
    <div class="card-header bg-info flex"
         style="height: 50px; align-items: center">
      <div class="card-title card-padding c-white flex"
           id="toggle-linear"
           style="align-items: center">
        <h2>
          <span *ngIf="!this.advertising">{{'advertising.dialog.create-or-modify.create-title' | translate}}</span>
          <span
            *ngIf="this.advertising && !duplicate">{{'advertising.dialog.create-or-modify.modify-title' | translate}}</span>
          <span
            *ngIf="this.advertising && duplicate">{{'advertising.dialog.create-or-modify.duplicate-title' | translate}}</span>
        </h2>
      </div>
    </div>
    <div class="columns small-12">
      <h5><p>{{'advertising.dialog.create-or-modify.explanation' | translate}}</p></h5>
    </div>
    <form [formGroup]="advertisingForm" class="bg-white">
      <div class="row margin-b-l margin-l-l">
        <mat-checkbox formControlName="actif" id="actif">
          {{'advertising.dialog.create-or-modify.input.actif' | translate}}
        </mat-checkbox>
      </div>
      <div class="row">
        <div class="small-6 columns">
          <mat-form-field [style.width.px]=400 class="mat-form-field-title">
            <input formControlName="title"
                   matInput name="title"
                   placeholder="{{'advertising.dialog.create-or-modify.input.title' | translate}}" required>
          </mat-form-field>
        </div>
        <div class="small-6 columns">
          <mat-form-field [style.width.px]=400>
            <input formControlName="fileBackground" matInput name="fileBackground" required
                   placeholder="{{'advertising.dialog.create-or-modify.input.image-background' | translate}}"
                   readonly/>
            <input #UploadFileInput (change)="fileChangeEvent($event)" accept="image/*" id="fileUpload"
                   multiple="multiple" required
                   name="fileUpload" type="file"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="small-6 columns">
          <mat-form-field class="mat-form-field-titleHtml">
          <textarea formControlName="titleHtml"
                    matInput name="titleHtml"
                    placeholder="{{'advertising.dialog.create-or-modify.input.titleHtml' | translate}}" required
                    style="resize: none;">
             </textarea>
          </mat-form-field>
          <mat-form-field class="mat-form-field-titleHtml">
          <textarea formControlName="chapeauHtml"
                    matInput
                    name="chapeauHtml"
                    placeholder="{{'advertising.dialog.create-or-modify.input.chapeauHtml' | translate}}"
                    style="resize: none;"
          >
             </textarea>
          </mat-form-field>
        </div>
        <div class="small-6 columns">
          <mat-form-field class="mat-form-field-textHtml">
              <textarea draggable="false"
                        formControlName="textHtml" matInput
                        name="textHtml"
                        placeholder="{{'advertising.dialog.create-or-modify.input.text' | translate}}" required
                        style="height: 125px; resize: none;">
                    </textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="small-6 columns">
          <mat-form-field>
            <input [matDatepicker]="startDatePicker" formControlName="startDate" matInput
                   name="startDate" placeholder="{{'advertising.dialog.create-or-modify.input.start-date' | translate}}"
                   required>
            <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="small-6 columns">
          <mat-form-field>
            <input [matDatepicker]="endDatePicker" formControlName="endDate" matInput
                   name="endDate" placeholder="{{'advertising.dialog.create-or-modify.input.end-date' | translate}}"
                   required>
            <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="small-6 columns">
          <mat-form-field [style.width.px]=400>
            <input (change)="onChangeActionBtLabel($event)" formControlName="actionBtLabel" matInput
                   name="actionBtLabel"
                   placeholder="{{'advertising.dialog.create-or-modify.input.action-bt-label' | translate}}">
          </mat-form-field>
        </div>
        <div class="small-6 columns">
          <mat-form-field [style.width.px]=400>
            <input formControlName="actionBtLink" matInput name="actionBtLink"
                   placeholder="{{'advertising.dialog.create-or-modify.input.action-bt-link' | translate}}">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="small-6 columns">
          <mat-form-field>
            <mat-select formControlName="requiredApplications" name="requiredApplications"
                        placeholder="{{'advertising.dialog.create-or-modify.input.required-applications' | translate}}"
                        multiple="true">
              <mat-option *ngFor="let app of applications"
                          [value]="app.key">
                <span>
                  {{ app.label }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="small-12 columns text-right margin-t-l margin-b-l">
        <button (click)="closeDialog()" class="margin-r-xs"
                mat-button> {{'advertising.dialog.create-or-modify.cancel' | translate }}</button>
        <button (click)="preview()" [disabled]="advertisingForm?.status === 'INVALID'" class="margin-r-xs" mat-button
                value="Preview">{{'advertising.dialog.create-or-modify.preview' | translate }}</button>
        <button (click)="onSave()" [disabled]="advertisingForm?.status === 'INVALID'" class="margin-r-xs" mat-button
                value="Enregistrer">{{'advertising.dialog.create-or-modify.save' | translate }}</button>
      </div>
    </form>
  </div>
</div>
